<template>
  <div class="pui-wrapper page-error">
    <div class="content">
      <img :src="imgLogoConnexion" />
      <div class="e404 message">
        <p class="uppercase">
          <slot name="title">Oops !</slot>
        </p>
        <p><slot name="subtitle">Something went wrong</slot></p>
        <pui-button @click="reload" variant="primary">
          <slot name="action">Click to reload</slot>
        </pui-button>
      </div>
    </div>
  </div>
</template>
<script>
import imgLogoConnexion from '../../static/img/piivo-logo-connexion.svg';

export default {
  components: {},
  data() {
    return {
      imgLogoConnexion,
    };
  },
  methods: {
    reload() {
      // Force change to "/", which will also reload the app
      window.location = '/';
    },
  },
};
</script>
